var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, ViewChild, HostListener, ElementRef } from '@angular/core';
import { EventName, Events } from '../../../utils/events';
import { AppNavProvider } from '../../../providers/app_nav';
import { UserProvider } from '../../../providers/user';
import { DatasetProvider } from '../../../providers/dataset';
import { NavSidebarProvider, SidebarClass, OutOfSyncState } from '../../../providers/nav-sidebar';
import { DatasetNavBarProvider, DatasetNavLocation } from '../../../providers/dataset_navbar';
import { CanvasProvider } from '../../../providers/workspace/canvas';
import { LocalStorageProvider } from '../../../providers/local-storage';
import { ActiveToolProvider } from '../../../providers/workspace/active-tool';
import { BoostJobUXState, BoostProvider } from '../../../providers/boost';
import { ProjectProvider } from '../../../providers/project';
import { ModalProvider } from '../../../providers/popup/modal';
import { SettingsProvider, SettingLifetime } from '../../../providers/settings';
import { AccountSettingsViews } from '../settings-sidebar/settings-sidebar';
import { JobProvider, JobState, JobType } from '../../../providers/job';
import { SidebarJobProvider } from '../../../providers/sidebar-job';
import { TrackableJobProvider } from '../../../providers/trackable-job';
import { TranslateService } from '@ngx-translate/core';
import { OnPremiseProvider } from '../../../providers/on-premise';
var MAX_JOBS_TO_DISPLAY = 3;
var NavSidebarComponent = /** @class */ (function () {
    function NavSidebarComponent(appNavProvider, events, userProvider, navSidebarProvider, datasetProvider, datasetNavProvider, canvasProvider, activeToolProvider, jobProvider, boostProvider, projectProvider, modalProvider, settingsProvider, localStorageProvider, sidebarJobProvider, trackableJobProvider, translate, onPremiseProvider) {
        var _this = this;
        this.appNavProvider = appNavProvider;
        this.events = events;
        this.userProvider = userProvider;
        this.navSidebarProvider = navSidebarProvider;
        this.datasetProvider = datasetProvider;
        this.datasetNavProvider = datasetNavProvider;
        this.canvasProvider = canvasProvider;
        this.activeToolProvider = activeToolProvider;
        this.jobProvider = jobProvider;
        this.boostProvider = boostProvider;
        this.projectProvider = projectProvider;
        this.modalProvider = modalProvider;
        this.settingsProvider = settingsProvider;
        this.localStorageProvider = localStorageProvider;
        this.sidebarJobProvider = sidebarJobProvider;
        this.trackableJobProvider = trackableJobProvider;
        this.translate = translate;
        this.onPremiseProvider = onPremiseProvider;
        this.projects = [];
        this.sidebarJobs = [];
        this.hasBrainCapability = false;
        this.projectListVisible = false;
        this.datasetListVisible = false;
        this.projectListStyles = {};
        this.datasetListStyles = {};
        this.OutOfSyncState = OutOfSyncState;
        this.projectSearchQuery = '';
        this.datasetSearchQuery = '';
        this.filteredProjects = [];
        this.filteredDatasets = [];
        this.projectListHasScrolling = false;
        this.datasetListHasScrolling = false;
        this.isLicenseExpiringSoon = false;
        this.onTrackableJobFinished = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.reloadDataset()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        this.onTrackableJobCanceled = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.reloadDataset()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        this.onTrainFinished = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.reloadDataset()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        this.onTrackableJobsPolled = function (jobsEventData) {
            _this.updateJobSidebar(jobsEventData);
        };
        this.onJobDismissed = function (jobsEventData) {
            _this.updateJobSidebar(jobsEventData);
        };
        this.onDatasetReloaded = function () {
            setTimeout(function () {
                if (_this.datasetIdentifier && _this.projectIdentifier) {
                    _this.dataset = _this.datasetProvider.getDatasetById(_this.datasetIdentifier);
                    _this.datasets = _this.getDatasets();
                    _this.project = _this.projectProvider.getProjectById(_this.projectIdentifier);
                }
            }, 0);
        };
        this.onUploadDone = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.datasetIdentifier) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.datasetProvider.reloadDataset(this.datasetIdentifier)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
    }
    // To close the menus, we must check for an outside click.
    // We also clear the search query upon outside click.
    NavSidebarComponent.prototype.onClick = function (target) {
        if (this.projectDropdown && !this.projectDropdown.nativeElement.contains(target)) {
            this.projectListVisible = false;
            this.projectSearchQuery = '';
            this.filteredProjects = this.projects;
        }
        if (this.datasetDropdown && !this.datasetDropdown.nativeElement.contains(target)) {
            this.datasetListVisible = false;
            this.datasetSearchQuery = '';
            this.filteredDatasets = this.datasets;
        }
    };
    NavSidebarComponent.prototype.onPopState = function () {
        this.projectListVisible = false;
        this.datasetListVisible = false;
    };
    NavSidebarComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var licenseExpirationDate, contentClass;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.settingsProvider.load()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.datasetProvider.load()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.projectProvider.load()];
                    case 3:
                        _a.sent();
                        this.isExpanded = this.settingsProvider.get('navSidebar.isExpanded');
                        return [4 /*yield*/, this.showEnvWarning()];
                    case 4:
                        if (_a.sent()) {
                            this.localStorageProvider.set('warningShownThisSession', 'true');
                            this.modalProvider
                                .createModal('SuboptimalEnvWarningModal', {}, { cssClass: this.getClientEnvWarningClass() })
                                .present();
                        }
                        return [4 /*yield*/, this.onPremiseProvider.getLicenseExpirationDate()];
                    case 5:
                        licenseExpirationDate = _a.sent();
                        this.isLicenseExpiringSoon =
                            licenseExpirationDate !== '' && this.onPremiseProvider.isLicenseExpiringSoon(licenseExpirationDate);
                        this.projectsSubscription = this.projectProvider.projectsSubscription.subscribe(function (projects) {
                            var sortedProjects = projects.sort(function (a, b) {
                                return a.name.localeCompare(b.name);
                            });
                            // Dereference the projects subscription data to prevent a bug with the dropdown during
                            // navigation between various projects.
                            _this.projects = sortedProjects.slice();
                            _this.filteredProjects = _this.projects;
                        });
                        this.metadataSubscription = this.navSidebarProvider.currentMetadataSubscription.subscribe(function (metadata) {
                            if (!metadata) {
                                return;
                            }
                            _this.hasNavbar = metadata.hasNavbar;
                            _this.isSettingsPage = metadata.isSettingsPage;
                            _this.projectIdentifier = metadata.projectIdentifier;
                            _this.datasetIdentifier = metadata.datasetIdentifier;
                            _this.settingsView = metadata.settingsView;
                            if (_this.datasetIdentifier) {
                                _this.dataset = _this.datasetProvider.getDatasetById(_this.datasetIdentifier);
                                _this.hasBrainCapability = _this.datasetProvider.hasBrainCapability(_this.datasetIdentifier);
                            }
                            else {
                                _this.dataset = undefined;
                                _this.hasBrainCapability = false;
                            }
                            if (_this.projectIdentifier) {
                                _this.project = _this.projectProvider.getProjectById(_this.projectIdentifier);
                            }
                            else {
                                _this.project = undefined;
                            }
                            _this.datasets = _this.getDatasets();
                            _this.filteredDatasets = _this.datasets;
                        });
                        if (this.projectIdentifier) {
                            this.project = this.projectProvider.getProjectById(this.projectIdentifier);
                        }
                        if (this.datasetIdentifier) {
                            this.hasBrainCapability = this.datasetProvider.hasBrainCapability(this.datasetIdentifier);
                        }
                        this.events.subscribe(EventName.DatasetReloaded, this.onDatasetReloaded);
                        this.events.subscribe(EventName.TrackableJobFinished, this.onTrackableJobFinished);
                        this.events.subscribe(EventName.TrackableJobCanceled, this.onTrackableJobCanceled);
                        this.events.subscribe(EventName.TrainFinished, this.onTrainFinished);
                        this.events.subscribe(EventName.TrackableJobsPolled, this.onTrackableJobsPolled);
                        this.events.subscribe(EventName.JobDismissed, this.onJobDismissed);
                        this.events.subscribe(EventName.UploadDone, this.onUploadDone);
                        if (!(this.dataset && this.dataset.brain)) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.trackableJobProvider.loadJobStates(this.dataset.id)];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7:
                        contentClass = this.isExpanded ? SidebarClass.EXPANDED : SidebarClass.COLLAPSED;
                        this.navSidebarProvider.setContentClass(contentClass);
                        return [2 /*return*/];
                }
            });
        });
    };
    NavSidebarComponent.prototype.ngOnChanges = function (changes) {
        if (changes.projectIdentifier &&
            changes.projectIdentifier.currentValue !== changes.projectIdentifier.previousValue) {
            if (this.projectIdentifier) {
                this.project = this.projectProvider.getProjectById(this.projectIdentifier);
            }
            else {
                this.project = undefined;
            }
        }
    };
    NavSidebarComponent.prototype.ngOnDestroy = function () {
        this.events.unsubscribe(EventName.DatasetReloaded, this.onDatasetReloaded);
        this.events.unsubscribe(EventName.TrackableJobFinished, this.onTrackableJobFinished);
        this.events.unsubscribe(EventName.TrackableJobCanceled, this.onTrackableJobCanceled);
        this.events.unsubscribe(EventName.TrainFinished, this.onTrainFinished);
        this.events.unsubscribe(EventName.TrackableJobsPolled, this.onTrackableJobsPolled);
        this.events.unsubscribe(EventName.JobDismissed, this.onJobDismissed);
        this.events.unsubscribe(EventName.UploadDone, this.onUploadDone);
        this.projectsSubscription.unsubscribe();
        this.metadataSubscription.unsubscribe();
    };
    NavSidebarComponent.prototype.reloadDataset = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.datasetIdentifier && this.projectIdentifier)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.datasetProvider.reloadDataset(this.datasetIdentifier)];
                    case 1:
                        _a.dataset = _b.sent();
                        this.datasets = this.getDatasets();
                        this.project = this.projectProvider.getProjectById(this.projectIdentifier);
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    NavSidebarComponent.prototype.updateJobSidebar = function (jobsEventData) {
        var oldSidebarJobs = this.sidebarJobs;
        this.sidebarJobs = this.getSidebarJobs(jobsEventData.jobs);
        if (this.sidebarJobs.length > MAX_JOBS_TO_DISPLAY &&
            this.hasNewJob(oldSidebarJobs, this.sidebarJobs) &&
            this.jobsScroller) {
            this.jobsScroller.nativeElement.scrollTop = this.jobsScroller.nativeElement.scrollHeight;
        }
    };
    NavSidebarComponent.prototype.showEnvWarning = function () {
        return __awaiter(this, void 0, void 0, function () {
            var hideEnvWarning, warningShownThisSession, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        hideEnvWarning = this.settingsProvider.get('banner.envWarning.hide');
                        return [4 /*yield*/, this.localStorageProvider.get('warningShownThisSession')];
                    case 1:
                        warningShownThisSession = _a.sent();
                        if (hideEnvWarning || warningShownThisSession === 'true') {
                            return [2 /*return*/, false];
                        }
                        if (navigator.userAgent.toLowerCase().indexOf('mobile') != -1) {
                            return [2 /*return*/, true];
                        }
                        return [2 /*return*/, (navigator.vendor != 'Google Inc.' ||
                                (window.screen.availHeight < 800 && window.screen.availWidth < 1280))];
                    case 2:
                        e_1 = _a.sent();
                        throw e_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    NavSidebarComponent.prototype.getClientEnvWarningClass = function () {
        var screenInfo = window.screen;
        if (screenInfo.availHeight <= 800 || screenInfo.availWidth <= 1280) {
            if (screenInfo.availHeight < screenInfo.availWidth || screenInfo.availWidth >= 768) {
                return 'modal-suboptimal-env-phone-landscape';
            }
            return 'modal-suboptimal-env-phone-portrait';
        }
        return 'modal-suboptimal-env-computer';
    };
    NavSidebarComponent.prototype.toggleExpanded = function (event) {
        event.stopPropagation();
        event.preventDefault();
        this.isExpanded = !this.isExpanded;
        var contentClass = this.isExpanded ? SidebarClass.EXPANDED : SidebarClass.COLLAPSED;
        this.navSidebarProvider.setContentClass(contentClass);
        this.settingsProvider.set('navSidebar.isExpanded', this.isExpanded, SettingLifetime.Session);
        // Hide the project/dataset dropdowns when collapsing the menu.
        if (!this.isExpanded) {
            this.projectListVisible = false;
            this.datasetListVisible = false;
        }
    };
    /**
     * Breadcrumb styles & links
     * NOTE: These previously lived in the dataset navbar component!
     * We are only porting over the functions relevant to the left side nav-buttons in BB-4235!
     * The rest will be implemented in future features.
     */
    NavSidebarComponent.prototype.canViewBrainPages = function () {
        return this.hasBrainCapability;
    };
    NavSidebarComponent.prototype.isDatasetDashboard = function () {
        return this.datasetNavProvider.getActivePage() === DatasetNavLocation.DatasetDashboard;
    };
    NavSidebarComponent.prototype.isImageLibrary = function () {
        return this.datasetNavProvider.getActivePage() === DatasetNavLocation.ImageLibrary;
    };
    NavSidebarComponent.prototype.goToDatasetDashboard = function () {
        if (!this.isDatasetDashboard()) {
            this.appNavProvider.getNavController().setRoot('DatasetPage', {
                datasetIdentifier: this.datasetIdentifier
            });
        }
    };
    NavSidebarComponent.prototype.isWorkspace = function () {
        return this.datasetNavProvider.getActivePage() === DatasetNavLocation.Workspace;
    };
    NavSidebarComponent.prototype.canEnterWorkspace = function () {
        return (this.dataset !== undefined &&
            this.dataset.imageCounts !== undefined &&
            this.dataset.imageCounts.total !== undefined &&
            this.dataset.imageCounts.total > 0);
    };
    NavSidebarComponent.prototype.workspaceNavText = function () {
        return this.hasBrainCapability
            ? this.translate.instant('Train Brain')
            : this.translate.instant('Annotate Dataset');
    };
    NavSidebarComponent.prototype.goToWorkspace = function (taggingTool) {
        if (taggingTool === void 0) { taggingTool = null; }
        if (!this.isWorkspace()) {
            this.appNavProvider.getNavController().setRoot('WorkspacePage', {
                datasetIdentifier: this.datasetIdentifier,
                taggingTool: taggingTool
            });
        }
        else if (taggingTool) {
            this.activeToolProvider.setActiveTool(taggingTool);
        }
    };
    NavSidebarComponent.prototype.isOnDetectionTrainingPage = function () {
        return this.datasetNavProvider.getActivePage() === DatasetNavLocation.DetectionTraining;
    };
    NavSidebarComponent.prototype.canTrainDetectionBrain = function () {
        if (!this.dataset) {
            return false;
        }
        return this.datasetProvider.canTrainDetectionBrain(this.dataset.id);
    };
    NavSidebarComponent.prototype.goToDetectionBrain = function () {
        if (this.canTrainDetectionBrain()) {
            this.appNavProvider.getNavController().setRoot("DetectionTrainingPage", {
                datasetIdentifier: this.datasetIdentifier
            });
        }
    };
    NavSidebarComponent.prototype.canViewDetectionTraining = function () {
        return this.userProvider.hasDetectionBrainsCapability();
    };
    NavSidebarComponent.prototype.isEvaluateBrain = function () {
        return this.datasetNavProvider.getActivePage() === DatasetNavLocation.EvaluateBrain;
    };
    NavSidebarComponent.prototype.canEvaluateBrain = function () {
        if (!this.dataset) {
            return false;
        }
        return this.datasetProvider.canEvaluateBrain(this.dataset.id);
    };
    NavSidebarComponent.prototype.goToEvaluateBrain = function () {
        if (this.canEvaluateBrain()) {
            this.appNavProvider.getNavController().setRoot("EvaluateBrainPage", {
                datasetIdentifier: this.datasetIdentifier
            });
        }
    };
    NavSidebarComponent.prototype.isTestBrain = function () {
        return this.datasetNavProvider.getActivePage() === DatasetNavLocation.TestBrain;
    };
    NavSidebarComponent.prototype.isLearningBrainTrained = function () {
        return (this.dataset !== undefined && this.dataset.brain !== undefined && this.dataset.brain.dateTrained !== null);
    };
    NavSidebarComponent.prototype.isFrozenBrainTrained = function () {
        return this.dataset !== undefined && this.dataset.brain !== undefined && this.dataset.brain.dateFrozen !== null;
    };
    NavSidebarComponent.prototype.isHiFiBrainTrained = function () {
        return (this.dataset !== undefined &&
            this.dataset.brain !== undefined &&
            this.dataset.brain.dateHiFiCreated !== null);
    };
    NavSidebarComponent.prototype.canTestBrain = function () {
        if (!this.dataset) {
            return false;
        }
        return this.datasetProvider.canTestBrain(this.dataset);
    };
    NavSidebarComponent.prototype.goToTestBrain = function () {
        if (this.canTestBrain()) {
            this.appNavProvider.getNavController().setRoot("TestSetPage", {
                datasetIdentifier: this.datasetIdentifier
            });
        }
    };
    NavSidebarComponent.prototype.isDeployBrain = function () {
        return this.datasetNavProvider.getActivePage() === DatasetNavLocation.DeployBrain;
    };
    NavSidebarComponent.prototype.canDeployBrain = function () {
        if (!this.dataset) {
            return false;
        }
        return this.datasetProvider.canDeployBrain(this.dataset);
    };
    NavSidebarComponent.prototype.canSeeDeployBrainButton = function () {
        return ((this.userProvider.hasBrainPromotionCapability() || this.userProvider.hasInferenceAPICapability()) &&
            !this.userProvider.hasWhitelabelDownloadCapability());
    };
    NavSidebarComponent.prototype.goToDeployBrain = function () {
        if (this.canDeployBrain()) {
            this.appNavProvider.getNavController().setRoot("DeployPage", {
                datasetIdentifier: this.datasetIdentifier
            });
        }
    };
    NavSidebarComponent.prototype.isOnExportWhiteLabelBrainPage = function () {
        return this.datasetNavProvider.getActivePage() === DatasetNavLocation.ExportWhiteLabelBrain;
    };
    NavSidebarComponent.prototype.canExportWhiteLabelBrain = function () {
        return this.isLearningBrainTrained();
    };
    NavSidebarComponent.prototype.isSonyUser = function () {
        return this.userProvider.isSonyUser();
    };
    NavSidebarComponent.prototype.goToExportWhiteLabelBrain = function () {
        if (this.canExportWhiteLabelBrain()) {
            this.appNavProvider.getNavController().setRoot("ExportWhiteLabelBrainPage", {
                datasetIdentifier: this.datasetIdentifier
            });
        }
    };
    NavSidebarComponent.prototype.canExport = function () {
        return this.dataset ? !this.isSceneRecognitionDataset() : false;
    };
    NavSidebarComponent.prototype.brainIsDirty = function () {
        if (this.dataset && this.dataset.brain) {
            return this.dataset.brain.dirty || this.dataset.isFrozenBrainOutdated();
        }
        return false;
    };
    // Used for both LC and AR brains
    NavSidebarComponent.prototype.learningBrainIsDirty = function () {
        if (this.dataset && this.dataset.brain) {
            return this.dataset.brain.dirty;
        }
        return false;
    };
    NavSidebarComponent.prototype.frozenBrainIsDirty = function () {
        if (this.dataset) {
            return this.dataset.isFrozenBrainOutdated();
        }
        return false;
    };
    NavSidebarComponent.prototype.hifiBrainIsDirty = function () {
        if (this.dataset) {
            return this.dataset.isHiFiBrainOutdated();
        }
        return false;
    };
    NavSidebarComponent.prototype.isSceneRecognitionDataset = function () {
        return this.dataset !== undefined && this.dataset.isSceneRecognition();
    };
    NavSidebarComponent.prototype.isAnomalyDataset = function () {
        return this.dataset !== undefined && this.dataset.isAnomalyRecognition();
    };
    NavSidebarComponent.prototype.isDetectionDataset = function () {
        return this.dataset !== undefined && this.dataset.isObjectDetection();
    };
    NavSidebarComponent.prototype.isTrainableDataset = function () {
        return this.isAnomalyDataset() || this.isSceneRecognitionDataset();
    };
    NavSidebarComponent.prototype.goToMainDashboard = function () {
        this.appNavProvider.getNavController().setRoot('DashboardPage');
    };
    NavSidebarComponent.prototype.toggleProjectList = function (event) {
        var _this = this;
        event.stopPropagation();
        event.preventDefault();
        this.datasetListVisible = false;
        this.projectListVisible = !this.projectListVisible;
        this.recalculateProjectListMenuStyles();
        // Must wrap in setTimeout to work
        setTimeout(function () {
            if (_this.projectSearch && _this.projectSearch.nativeElement) {
                _this.projectSearch.nativeElement.focus();
            }
            if (_this.projectList) {
                _this.projectListHasScrolling =
                    _this.projectList.nativeElement.scrollHeight > _this.projectList.nativeElement.clientHeight;
            }
        }, 0);
    };
    NavSidebarComponent.prototype.toggleDatasetList = function (event) {
        var _this = this;
        event.stopPropagation();
        event.preventDefault();
        this.projectListVisible = false;
        this.datasetListVisible = !this.datasetListVisible;
        this.recalculateDatasetListMenuStyles();
        // Must wrap in setTimeout to work
        setTimeout(function () {
            _this.datasetSearch.nativeElement.focus();
            if (_this.datasetList) {
                _this.datasetListHasScrolling =
                    _this.datasetList.nativeElement.scrollHeight > _this.datasetList.nativeElement.clientHeight;
            }
        }, 0);
    };
    NavSidebarComponent.prototype.recalculateProjectListMenuStyles = function () {
        if (!this.projectListVisible || !this.projectListButton || !this.projectListButton.nativeElement) {
            return;
        }
        var bounds = this.projectListButton.nativeElement.getBoundingClientRect();
        this.projectListStyles = {
            // Ensure 4 px of vertical margins between the main button and the list.
            'top.px': bounds.bottom + 21
        };
    };
    NavSidebarComponent.prototype.recalculateDatasetListMenuStyles = function () {
        if (!this.datasetListVisible || !this.datasetListButton || !this.datasetListButton.nativeElement) {
            return;
        }
        var bounds = this.datasetListButton.nativeElement.getBoundingClientRect();
        this.datasetListStyles = {
            // Ensure 4 px of vertical margins between the main button and the list.
            'top.px': bounds.bottom + 21
        };
    };
    NavSidebarComponent.prototype.projectIsSelected = function (projectID) {
        return this.project !== undefined && projectID === this.project.id;
    };
    NavSidebarComponent.prototype.datasetIsSelected = function (datasetID) {
        return this.dataset !== undefined && datasetID === this.dataset.id;
    };
    NavSidebarComponent.prototype.canCreateProject = function () {
        return this.userProvider.canManageProjects();
    };
    NavSidebarComponent.prototype.canCreateDataset = function () {
        return this.userProvider.canManageDatasets();
    };
    NavSidebarComponent.prototype.showCreateProjectModal = function () {
        var _this = this;
        var createProjectModal = this.modalProvider.createModal('CreateProjectModal', {}, { cssClass: 'modal-create-project' });
        createProjectModal.onDidDismiss(function (data) {
            if (data && data.success && data.project) {
                _this.createProjectCallback(data.project);
            }
        });
        createProjectModal.present();
        this.projectListVisible = false;
    };
    NavSidebarComponent.prototype.createProjectCallback = function (project) {
        if (project && project.datasetIdentifiers.length > 0) {
            this.appNavProvider.getNavController().setRoot("DatasetPage", {
                datasetIdentifier: project.datasetIdentifiers[0]
            });
        }
        else {
            this.appNavProvider.getNavController().setRoot("ProjectPage", {
                projectIdentifier: project.id
            });
        }
    };
    NavSidebarComponent.prototype.navigateToCreateDatasetPage = function () {
        this.datasetListVisible = false;
        this.appNavProvider
            .getNavController()
            .setRoot("CreateDatasetPage", { projectIdentifier: this.projectIdentifier });
    };
    NavSidebarComponent.prototype.navigateToProject = function (projectID) {
        this.appNavProvider.getNavController().setRoot("ProjectPage", {
            projectIdentifier: projectID
        });
        this.projectListVisible = false;
    };
    NavSidebarComponent.prototype.navigateToDataset = function (datasetID) {
        this.appNavProvider.getNavController().setRoot("DatasetPage", {
            datasetIdentifier: datasetID
        });
        this.datasetListVisible = false;
    };
    NavSidebarComponent.prototype.navigateToSettingsPage = function () {
        this.appNavProvider.getNavController().setRoot('AccountPage', {
            subPage: AccountSettingsViews.ABOUT,
            previousProjectIdentifier: this.projectIdentifier,
            previousDatasetIdentifier: this.datasetIdentifier
        });
    };
    NavSidebarComponent.prototype.getUserInformation = function () {
        var userInfo = this.userProvider.getUserInformation();
        return userInfo && userInfo.name;
    };
    NavSidebarComponent.prototype.getDatasets = function () {
        // For tagger / annotator account we can get all the datasets assigned to the user
        if (this.userProvider.isTaggerUser()) {
            return this.datasetProvider.getDatasets();
        }
        if (this.projectIdentifier) {
            return this.datasetProvider.getDatasetsForProject(this.projectIdentifier);
        }
        return [];
    };
    NavSidebarComponent.prototype.getProjectsDropdownString = function () {
        if (this.project) {
            return this.project.name;
        }
        return this.translate.instant('Select') + "...";
    };
    NavSidebarComponent.prototype.getDatasetsDropdownString = function () {
        if (this.dataset) {
            return this.dataset.name;
        }
        return this.translate.instant('Select') + "...";
    };
    NavSidebarComponent.prototype.canShowDatasetsDropdown = function () {
        return this.project || this.userProvider.isTaggerUser() ? true : false;
    };
    NavSidebarComponent.prototype.isDatasetsDropdownDisabled = function () {
        if (this.userProvider.isTaggerUser()) {
            return false;
        }
        return !this.datasets.length;
    };
    NavSidebarComponent.prototype.handleSyncNavigation = function (currentState) {
        switch (currentState) {
            case OutOfSyncState.AnomalyRecognizer:
            case OutOfSyncState.LearningClassifier:
            case OutOfSyncState.WhiteLabelLearningClassifier:
                this.showRetrainProgress();
                break;
            case OutOfSyncState.Detector:
                this.appNavProvider.getNavController().setRoot("DetectionTrainingPage", {
                    datasetIdentifier: this.datasetIdentifier
                });
                break;
            case OutOfSyncState.AnomalyHiFi:
                this.appNavProvider.getNavController().setRoot("EvaluateBrainPage", {
                    rebuildAnomalyHiFi: true,
                    datasetIdentifier: this.datasetIdentifier
                });
                break;
            case OutOfSyncState.StaticClassifier:
            case OutOfSyncState.WhiteLabelStaticClassifier:
                this.appNavProvider.getNavController().setRoot("EvaluateBrainPage", {
                    rebuildStaticClassifier: true,
                    datasetIdentifier: this.datasetIdentifier
                });
                break;
        }
    };
    NavSidebarComponent.prototype.allowToDismissJob = function (job) {
        return [JobState.DONE, JobState.CANCELED, JobState.ERROR].includes(job.state);
    };
    NavSidebarComponent.prototype.dismissJob = function (job) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.jobProvider.dismiss(job.jobIdentifier)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.trackableJobProvider.restartJobPolling()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NavSidebarComponent.prototype.dismissJobOnClick = function (job, event) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        event.stopPropagation();
                        return [4 /*yield*/, this.dismissJob(job)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NavSidebarComponent.prototype.goToDatasetJob = function (job) {
        return __awaiter(this, void 0, void 0, function () {
            var dataset;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.allowToDismissJob(job)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.dismissJob(job)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (job.datasetIdentifier) {
                            dataset = this.datasetProvider.getDatasetById(job.datasetIdentifier);
                            if (dataset) {
                                if (job.type == JobType.IncrementalTrain) {
                                    this.handleIncrementalTrainJob(job);
                                }
                                else if (job.type == JobType.Retrain) {
                                    this.handleRetrainJob(job);
                                }
                                else if (job.type == JobType.Optimize) {
                                    this.handleOptimizeJob(job);
                                }
                                else if (job.type == JobType.Freeze) {
                                    this.handleFreezeJob(job);
                                }
                                else if (job.type == JobType.AnomalyHiFi) {
                                    this.handleAnomalyHiFiJob(job);
                                }
                                else if (job.type == JobType.Train) {
                                    this.handleDetectionTrainJob(job);
                                }
                                else if (job.type == JobType.BrainExport) {
                                    this.handleBrainExportJob(job);
                                }
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    NavSidebarComponent.prototype.handleIncrementalTrainJob = function (job) {
        if (this.jobProvider.isJobDone(job.state) && job.state != JobState.ERROR) {
            this.appNavProvider.getNavController().setRoot("EvaluateBrainPage", {
                datasetIdentifier: job.datasetIdentifier
            });
        }
        else {
            this.boostProvider.showRetrainProgress(job.datasetIdentifier, BoostJobUXState.NEEDS_INCREMENTAL_TRAINING);
        }
    };
    NavSidebarComponent.prototype.handleRetrainJob = function (job) {
        if (this.jobProvider.isJobDone(job.state) && job.state != JobState.ERROR) {
            this.appNavProvider.getNavController().setRoot("EvaluateBrainPage", {
                datasetIdentifier: job.datasetIdentifier
            });
        }
        else {
            this.boostProvider.showRetrainProgress(job.datasetIdentifier, BoostJobUXState.OUT_OF_SYNC);
        }
    };
    NavSidebarComponent.prototype.handleOptimizeJob = function (job) {
        if (job.state === JobState.DONE) {
            this.appNavProvider.getNavController().setRoot("EvaluateBrainPage", {
                datasetIdentifier: job.datasetIdentifier,
                navigateToWorkingBrain: true
            });
        }
        else {
            this.appNavProvider.getNavController().setRoot("EvaluateBrainPage", {
                datasetIdentifier: job.datasetIdentifier,
                optimizeWorkingBrain: true,
                hasError: job.state === JobState.ERROR
            });
        }
    };
    NavSidebarComponent.prototype.handleFreezeJob = function (job) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.appNavProvider.getNavController().setRoot("EvaluateBrainPage", {
                    datasetIdentifier: job.datasetIdentifier,
                    navigateToStaticTab: true,
                    hasError: job.state === JobState.ERROR
                });
                return [2 /*return*/];
            });
        });
    };
    // Dismiss the first anomaly hi-fi build job for an AR brain is similar
    // to dismissing the first freeze job for an SC brain.
    NavSidebarComponent.prototype.handleAnomalyHiFiJob = function (job) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.appNavProvider.getNavController().setRoot("EvaluateBrainPage", {
                    datasetIdentifier: job.datasetIdentifier,
                    navigateToHiFiTab: true,
                    hasError: job.state === JobState.ERROR
                });
                return [2 /*return*/];
            });
        });
    };
    NavSidebarComponent.prototype.handleDetectionTrainJob = function (job) {
        if (this.jobProvider.isJobDone(job.state) && job.state === JobState.DONE) {
            this.appNavProvider.getNavController().setRoot('EvaluateBrainPage', {
                datasetIdentifier: job.datasetIdentifier
            });
        }
        else {
            this.appNavProvider.getNavController().setRoot("DetectionTrainingPage", {
                datasetIdentifier: job.datasetIdentifier,
                hasError: job.state === JobState.ERROR
            });
        }
    };
    NavSidebarComponent.prototype.handleBrainExportJob = function (job) {
        this.appNavProvider.getNavController().setRoot("ExportWhiteLabelBrainPage", {
            datasetIdentifier: job.datasetIdentifier,
            hasError: job.state === JobState.ERROR,
            downloadJobIdentifier: job.state === JobState.DONE ? job.jobIdentifier : undefined
        });
    };
    NavSidebarComponent.prototype.showRetrainProgress = function () {
        if (this.datasetIdentifier) {
            var initialBoostState = this.shouldShowIncrementalTrainingWarning()
                ? BoostJobUXState.NEEDS_INCREMENTAL_TRAINING
                : BoostJobUXState.OUT_OF_SYNC;
            this.boostProvider.showRetrainProgress(this.datasetIdentifier, initialBoostState);
        }
    };
    /**
     * Return true if either the learning classifier brain is dirty or there are newly tagged
     * assets that need training
     */
    NavSidebarComponent.prototype.shouldShowLearningClassifierSyncWarning = function () {
        return (this.isSceneRecognitionDataset() &&
            (this.learningBrainIsDirty() ||
                this.datasetProvider.hasNewlyTaggedAssetsForRecognitionTraining(this.dataset)));
    };
    NavSidebarComponent.prototype.shouldShowStaticClassifierSyncWarning = function () {
        if (!this.dataset || !this.isSceneRecognitionDataset()) {
            return false;
        }
        // For a WhiteLabel dataset's enableStaticClassifier property will be null,
        // so we need to account for that as well.
        if (!this.dataset.enableStaticClassifier) {
            return false;
        }
        return this.frozenBrainIsDirty();
    };
    /**
     * Return true if either the anomaly recognizer brain is dirty or there are newly tagged
     * assets that need training
     */
    NavSidebarComponent.prototype.shouldShowAnomalyRecognizerSyncWarning = function () {
        return (this.isAnomalyDataset() &&
            (this.learningBrainIsDirty() ||
                this.datasetProvider.hasNewlyTaggedAssetsForRecognitionTraining(this.dataset)));
    };
    NavSidebarComponent.prototype.shouldShowAnomalyHiFiSyncWarning = function () {
        if (!this.dataset || !this.isAnomalyDataset()) {
            return false;
        }
        if (!this.dataset.enableAnomalyHiFi) {
            return false;
        }
        return this.hifiBrainIsDirty();
    };
    NavSidebarComponent.prototype.shouldShowDetectionSyncWarning = function () {
        return this.isDetectionDataset() && this.learningBrainIsDirty();
    };
    // Due to the way out of sync warnings are instantiated, we need to check each case
    // to see if we're displaying any.
    NavSidebarComponent.prototype.shouldUseCollapsedSyncWarningStyles = function () {
        return (!this.isExpanded &&
            (this.shouldShowLearningClassifierSyncWarning() ||
                this.shouldShowStaticClassifierSyncWarning() ||
                this.shouldShowAnomalyRecognizerSyncWarning() ||
                this.shouldShowAnomalyHiFiSyncWarning()));
    };
    NavSidebarComponent.prototype.shouldShowNavBreadcrumbsBorder = function () {
        var showBorderWhenExpanded = this.isExpanded && (this.project !== undefined || this.dataset !== undefined);
        return showBorderWhenExpanded || this.shouldUseCollapsedSyncWarningStyles();
    };
    /**
     * Filter and sort data from polled jobs for display in the sidebar
     */
    NavSidebarComponent.prototype.getSidebarJobs = function (jobs) {
        return jobs
            .filter(function (job) { return job.state != JobState.CANCELED; })
            .sort(function (job1, job2) {
            return job1.dateProcessingStartedSeconds - job2.dateProcessingStartedSeconds;
        });
    };
    /** When the user is on the projects listing, we should always show the project listing if they have at least one project.
     * However, if they're actually viewing a project (or a dataset within a project), we should only show the list if they have more than one.
     * This change was implemented as part of BB-5933.
     */
    NavSidebarComponent.prototype.shouldShowProjectList = function () {
        return this.projects.length > 1 || this.project === undefined;
    };
    NavSidebarComponent.prototype.getSidebarJobTooltipText = function (job) {
        return this.sidebarJobProvider.getTooltip(job, this.shouldShowIndeterminateLoading(job));
    };
    NavSidebarComponent.prototype.getSidebarJobActionText = function (job) {
        return this.sidebarJobProvider.getAction(job);
    };
    NavSidebarComponent.prototype.getJobProgressData = function (job) {
        if (job) {
            var percentage = job.state == JobState.DONE ? 100 : this.jobProvider.getProgressPercentage(job);
            return {
                value: percentage.toString() + "%",
                name: 'JobProgress',
                color: '#30A8BC'
            };
        }
        else {
            return {
                value: "0%",
                name: 'JobProgress',
                color: '#30A8BC'
            };
        }
    };
    NavSidebarComponent.prototype.shouldShowIndeterminateLoading = function (job) {
        switch (job.state) {
            case JobState.CANCEL_REQUESTED:
            case JobState.CANCELING:
            case JobState.WAITING:
                return true;
            case JobState.DONE:
            case JobState.ERROR:
            case JobState.CANCELED:
                return false;
            default:
                return this.trackableJobProvider.isProgressIndeterminate(job.type);
        }
    };
    NavSidebarComponent.prototype.getJobsStyleHeight = function () {
        var numberOfJobs = this.sidebarJobs ? this.sidebarJobs.length : 0;
        var numberOfJobsToDisplay = Math.min(numberOfJobs, MAX_JOBS_TO_DISPLAY);
        var height = 48 * numberOfJobsToDisplay;
        return height + "px";
    };
    /**
     * Return true if there is a new job added to the newJobs array as compared to
     * the oldJobs array
     */
    NavSidebarComponent.prototype.hasNewJob = function (oldJobs, newJobs) {
        var latestOldJob = oldJobs && oldJobs.length ? oldJobs[oldJobs.length - 1] : null;
        var latestNewJob = newJobs && newJobs.length ? newJobs[newJobs.length - 1] : null;
        var latestOldJobStart = latestOldJob ? latestOldJob.dateProcessingStartedSeconds || 0 : 0;
        var latestNewJobStart = latestNewJob ? latestNewJob.dateProcessingStartedSeconds || 0 : 0;
        return latestNewJobStart > latestOldJobStart;
    };
    NavSidebarComponent.prototype.filterProjects = function () {
        var _this = this;
        this.filteredProjects = this.projects.filter(function (obj) {
            return obj.name.toLowerCase().includes(_this.projectSearchQuery.toLowerCase());
        });
    };
    NavSidebarComponent.prototype.filterDatasets = function () {
        var _this = this;
        this.filteredDatasets = this.datasets.filter(function (obj) {
            return obj.name.toLowerCase().includes(_this.datasetSearchQuery.toLowerCase());
        });
    };
    NavSidebarComponent.prototype.clearProjectsSearch = function (event) {
        this.projectSearchQuery = '';
        this.filteredProjects = this.projects;
        event.stopPropagation();
    };
    NavSidebarComponent.prototype.clearDatasetsSearch = function (event) {
        this.datasetSearchQuery = '';
        this.filteredDatasets = this.datasets;
        event.stopPropagation();
    };
    NavSidebarComponent.prototype.getTrainAnnotateTabText = function () {
        return this.isTrainableDataset() ? this.translate.instant('Train') : this.translate.instant('Annotate');
    };
    NavSidebarComponent.prototype.getDatasetDashboardTooltipText = function () {
        return this.isExpanded ? '' : this.translate.instant('Dataset Dashboard');
    };
    NavSidebarComponent.prototype.getEvaluateBrainTooltipText = function () {
        return this.isExpanded ? '' : this.translate.instant('Evaluate Brain');
    };
    NavSidebarComponent.prototype.getTestBrainTooltipText = function () {
        return this.isExpanded ? '' : this.translate.instant('Test Brain');
    };
    NavSidebarComponent.prototype.getDeployBrainTooltipText = function () {
        return this.isExpanded ? '' : this.translate.instant('Deploy Brain');
    };
    NavSidebarComponent.prototype.getExportBrainTooltipText = function () {
        return this.isExpanded ? '' : this.translate.instant('Export Brain');
    };
    /**
     * Return true to show a warning that more training is required, instead of showing
     * the standard out-of-sync warning
     */
    NavSidebarComponent.prototype.shouldShowIncrementalTrainingWarning = function () {
        return (this.datasetProvider.hasNewlyTaggedAssetsForRecognitionTraining(this.dataset) &&
            !this.learningBrainIsDirty());
    };
    NavSidebarComponent.prototype.shouldDisplayLicenseCountdown = function () {
        return (this.onPremiseProvider.isOnPremiseElectronApp() &&
            this.isLicenseExpiringSoon &&
            this.settingsView !== AccountSettingsViews.ABOUT);
    };
    __decorate([
        ViewChild('projectListButton'),
        __metadata("design:type", Object)
    ], NavSidebarComponent.prototype, "projectListButton", void 0);
    __decorate([
        ViewChild('datasetListButton'),
        __metadata("design:type", Object)
    ], NavSidebarComponent.prototype, "datasetListButton", void 0);
    __decorate([
        ViewChild('jobsScroller'),
        __metadata("design:type", ElementRef)
    ], NavSidebarComponent.prototype, "jobsScroller", void 0);
    __decorate([
        ViewChild('projectDropdown'),
        __metadata("design:type", ElementRef)
    ], NavSidebarComponent.prototype, "projectDropdown", void 0);
    __decorate([
        ViewChild('projectList'),
        __metadata("design:type", ElementRef)
    ], NavSidebarComponent.prototype, "projectList", void 0);
    __decorate([
        ViewChild('datasetDropdown'),
        __metadata("design:type", ElementRef)
    ], NavSidebarComponent.prototype, "datasetDropdown", void 0);
    __decorate([
        ViewChild('datasetList'),
        __metadata("design:type", ElementRef)
    ], NavSidebarComponent.prototype, "datasetList", void 0);
    __decorate([
        ViewChild('projectSearch'),
        __metadata("design:type", ElementRef)
    ], NavSidebarComponent.prototype, "projectSearch", void 0);
    __decorate([
        ViewChild('datasetSearch'),
        __metadata("design:type", ElementRef)
    ], NavSidebarComponent.prototype, "datasetSearch", void 0);
    __decorate([
        HostListener('document:click', ['$event.target']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [HTMLElement]),
        __metadata("design:returntype", void 0)
    ], NavSidebarComponent.prototype, "onClick", null);
    __decorate([
        HostListener('window:popstate'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], NavSidebarComponent.prototype, "onPopState", null);
    NavSidebarComponent = __decorate([
        Component({
            selector: 'nav-sidebar',
            templateUrl: 'nav-sidebar.html'
        }),
        __metadata("design:paramtypes", [AppNavProvider,
            Events,
            UserProvider,
            NavSidebarProvider,
            DatasetProvider,
            DatasetNavBarProvider,
            CanvasProvider,
            ActiveToolProvider,
            JobProvider,
            BoostProvider,
            ProjectProvider,
            ModalProvider,
            SettingsProvider,
            LocalStorageProvider,
            SidebarJobProvider,
            TrackableJobProvider,
            TranslateService,
            OnPremiseProvider])
    ], NavSidebarComponent);
    return NavSidebarComponent;
}());
export { NavSidebarComponent };
//# sourceMappingURL=nav-sidebar.js.map


// WEBPACK FOOTER //
// ./src/components/core/nav-sidebar/nav-sidebar.ts.pre-build-optimizer.js